import { Component, OnInit, forwardRef, Input, SimpleChanges } from '@angular/core';
import { 
    ToastController
} from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { DemoozDateToStringPipe } from '@demooz/pipes';
import { DemoozButtonComponent } from '@demooz/components';
import { DataService, AmbassadorService, MatchService } from '@app/services';

@Component({
    selector: 'app-demonstrations-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    imports: [
        TranslatePipe, DemoozDateToStringPipe, forwardRef(() => DemoozButtonComponent)
    ]
})
export class DemonstrationsItemComponent  implements OnInit {
      
    @Input({alias : 'match', required : true}) match: any;
    
    salesContent: any|null;
    demonstrationsContent: any|null;
    matchValidated: boolean = false;
    testerName: string;
    dateCreation: Date;
    isShareSupported: boolean = false;
    isFetchingValidate: boolean = false;
      
    constructor(             
        public translateService: TranslateService,
        private toastController: ToastController,
        public dataService: DataService,
        public ambassadorService: AmbassadorService,
        public matchService: MatchService
    ) { }

    ngOnInit() {
        this.isShareSupported = (typeof navigator.share === 'function');
        this.salesContent = this.dataService.operation.salesContent;
        this.demonstrationsContent = this.dataService.operation.demonstrationsContent;        
    }
    
    async ngOnChanges(changes: SimpleChanges) {    
        if(changes['match'] && changes['match'].currentValue){
            this.initMatch();
        }
    }
    
    initMatch(){
        this.matchValidated = (this.match.validation?.owner?.hasValidated === true && this.match.validation?.tester?.hasValidated === true);
        this.testerName = this.match.tester.firstName+' '+this.match.tester.lastName.charAt(0)+'.';        
        this.dateCreation = new Date(parseInt(this.match._.created));
    }
    
    callTester(){
        if(this.match.tester.phone){
            location.href = 'tel:'+this.match.tester.phone;
        }
    }
    
    sendSmsTester(){
        if(this.match.tester.phone){
            location.href = 'sms:'+this.match.tester.phone;
        }
    }
    
    async shareLinkSaleProof(){
        let linkReceipt = `${window.location.origin}/sale/post?m=${this.match.ID}&o=${this.dataService.operation.value?.ID}`;
        let shareData = {
            title: ' ',
            text: '',
            url: linkReceipt
        };
        await navigator.share(shareData);
    }
    
    async validateMatch(){
        this.isFetchingValidate = true;
        let status = await this.matchService.validateMatch(this.match.ID);   
        if(status){
            await this.ambassadorService.refreshAmbassador();            
            this.match = this.dataService.ambassador.matchesActives.find(m => m.ID === this.match.ID);
            this.initMatch();
            const toast = await this.toastController.create({
                message: this.translateService.instant('DEMONSTRATION.MSG_SUCCESS_VALIDATE_MATCH'),
                duration: 6000,
                position: 'top',
                color: 'success'
            });
            await toast.present();  
             
        }
        else{
            const toast = await this.toastController.create({
                message: this.translateService.instant('DEMONSTRATION.MSG_ERROR_VALIDATE_MATCH'),
                duration: 6000,
                position: 'top',
                color: 'danger'
            });
            await toast.present();
        }
        this.isFetchingValidate = false;
    }
}
